// import * as Yup from 'yup';
// // @mui
// import { LoadingButton } from '@mui/lab';
// import { alpha } from '@mui/material/styles';
import {
  Button,
  Typography,
  DialogActions,
  Divider,
  MenuItem,
  Dialog,
  Stack,
  Select,
  InputLabel,
  FormControl,
} from '@mui/material';
// @types
//import { NewPostFormValues } from '../../../@types/blog';
// import { Article } from 'src/@types/lms/article';
import { Role } from 'src/@types/lms/roles';
// components
// import Iconify from 'src/components/Iconify';
// import { RHFSelect } from 'src/components/hook-form';
import { useState } from 'react';
// import { yupResolver } from '@hookform/resolvers/yup';

import useAuth from '../../../hooks/useAuth';

// ----------------------------------------------------------------------

type Props = {
  values: Role[];
  isOpen: boolean;
  onClose: VoidFunction;
  onSubmitRole(role: Role): Promise<void>;
};

const defaultValues = {
  id: '',
  name: '',
  description: '',
  enabled: true,
};

export default function SelectRoleDialog({ values, isOpen, onClose, onSubmitRole }: Props) {
  const [roleSelected, setSelectedRole] = useState('');

  const { user } = useAuth();

  function selectRole() {
    if (roleSelected !== '') {
      let value = defaultValues;
      value.name = roleSelected;
      setSelectedRole('');
      onSubmitRole(value);
    }
  }

  return (
    <Dialog
      open={isOpen}
      onClose={(event, reason) => {
        if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
          onClose();
        }
      }}
      fullWidth
      maxWidth="md"
    >
      <DialogActions sx={{ py: 2, px: 3 }}>
        <Stack justifyContent={'flex-start'} sx={{ flexGrow: 1 }}>
          <Typography variant="subtitle1">Select Role to switch to</Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            Current Role: {user?.role}
          </Typography>
        </Stack>
        <Button onClick={onClose}>Cancel</Button>
      </DialogActions>

      <Stack alignItems="center" sx={{ mt: 3, mb: 3 }} spacing={2}>
        <FormControl sx={{ width: '60%' }}>
          <InputLabel id="select-label">Role</InputLabel>
          <Select
            labelId="select-label"
            id="roleSelect"
            label="Role"
            onChange={(event) => setSelectedRole(event.target.value)}
            value={roleSelected}
          >
            <MenuItem
              key=""
              value=""
              selected={true}
              sx={{
                mx: 1,
                borderRadius: 0.75,
                typography: 'body2',
                fontStyle: 'italic',
                color: 'text.secondary',
              }}
            >
              Select Role
            </MenuItem>
            <Divider />
            {values.map((option) => (
              <MenuItem
                key={option.name}
                value={option.name}
                sx={{
                  mx: 1,
                  my: 0.5,
                  borderRadius: 0.75,
                  typography: 'body2',
                  textTransform: 'capitalize',
                }}
              >
                {option.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Button onClick={selectRole} sx={{ width: '20%' }} variant="contained">
          Select
        </Button>
      </Stack>
    </Dialog>
  );
}

// ----------------------------------------------------------------------
